import {
  SET_STORE_DELIVERY_ZONE_DESCRIPTION,
  SET_STORE_CUSTOMER_DEFAULT_ADDRESS,
  SET_STORE_CUSTOMER_ADDRESSLIST,
  SET_STORE_DELIVERYZONEID,
  SET_STORE_ZONEID,
} from "../../database/store-data";
import {
  Get_CustomerAddressList,
  GET_SET_STORED_DATA,
  GET_PAGE_URL,
} from "../../database/get-stored-data";
import {
  STORE_CustomerDefaultAddress,
  STORE_DeliveryZoneID,
  STORE_PAGE_URL,
} from "../../database/store-names";
import {
  api_UpdateCustomerDeliveryAddress,
  api_GetCustomerDeliveryAddress,
} from "../../connection/api/api-profile";
import {
  dto_CustomerAddressList,
  dto_CustomerAddress,
} from "../../classes/dto-customer";
import {
  PT_ADDNEWADDRESS,
  PT_PROFILE,
} from "../../routes/stack/paths/pt-profile";
import { CONCAT_TEXT_LIMIT, HEADER_TAB_SETUP } from "../../functions/funtion";
import { CSP, ENCRYPT_STORAGE } from "../../config/config";
import { REQUEST_LOCATION } from "../../functions/mobile-intigrator";
import { ToastMessage } from "../../components/toast-notification/toast";
import { dto_common } from "../../classes/dto-common";
import { PT_HOME } from "../../routes/stack/paths/pt-home";
import { PT_CART } from "../../routes/stack/paths/pt-cart";
import Alert from "../../components/Alert";
import React from "react";
import "../../styles/css/pg-profile-addnew-address.css";
import "../../styles/css/pg-profile-menulist.css";
import { resolveAddressPhoneNo } from "../../functions/address-phone";

export default class ADDRESSLIST extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      AddressList: [],
      isLoading: true,
    };
  }

  async componentDidMount() {
    await REQUEST_LOCATION();
    this.setState({ isLoading: true }, async () => {
      this.setState({
        AddressList: await Get_CustomerAddressList(),
        isLoading: false,
      });
    });
    await GET_SET_STORED_DATA();

    var a = await GET_PAGE_URL();

    await HEADER_TAB_SETUP({
      HeaderTabName: CONCAT_TEXT_LIMIT({
        length: 20,
        string: " Address",
      }),
      FnGoBackScreen: () => {
        this.props.navigate(a);
        ENCRYPT_STORAGE.removeItem(STORE_PAGE_URL);
      },
      HeaderNavigatorMenuDisplay: false,
      FnHeaderNavigatorMenu: () => {},
    });
  }

  render() {
    return (
      <div
        className="addListHeader fadeInUp animated"
        style={{
          height: "100vh",
          fontSize: "15px",
        }}
      >
        {!this.state.isLoading ? (
          <div
            style={{
              marginBottom: "25px",
              fontSize: "20px",
              fontWeight: "bold",
            }}
            onClick={async () => {
              await REQUEST_LOCATION();
              this.props.navigate(PT_ADDNEWADDRESS);
            }}
          >
            <i
              className="bi bi-plus-circle-fill"
              aria-hidden="true"
              style={{
                marginRight: "10px",
                fontSize: "20px",
              }}
            />
            New address
          </div>
        ) : (
          ""
        )}

        {this.state.isLoading ? (
          <div style={{ marginTop: 300, position: "relative" }}>
            <div
              className="loader"
              style={{ marginTop: "90%", marginLeft: "45%" }}
            />
          </div>
        ) : (
          <div className="addList">
            <>
              {[...this.state.AddressList]
                .sort((a, b) => (b.IsDefault === true) - (a.IsDefault === true))
                .map((rs) => (
                <li
                  className="addListRow"
                  key={rs.GUID + "AddressList"}
                  style={{
                    backgroundColor: "#fefefe",
                    fontSize: "15px",
                    margin: 5,
                  }}
                >
                  <i className="bi bi-geo-alt-fill" aria-hidden="true" />

                  <div style={{ textAlign: "left" }}>
                    <p
                      style={{ margin: 0, fontWeight: 'bold' }}
                      onClick={() => this.SetDefaultCustomerAddress(rs.GUID)}
                    >
                      {rs.Add1 }
                    </p>
                    <p
                      style={{ margin: 0 }}
                      onClick={() => this.SetDefaultCustomerAddress(rs.GUID)}
                    >
                      { rs.Add2 + ", " + rs.Add3}
                    </p>
                    <label style={{ display: "none" }} id="GUIDAddress">
                      {rs.GUID}
                    </label>
                  </div>


                  {rs.IsDefault === true ? (
                    <i
                      className="bi bi-check2-circle"
                      aria-hidden="true"
                      style={{ color: "green" }}
                      onClick={() => {
                        this.SetDefaultCustomerAddress(rs.GUID);
                      }}
                    />
                  ) : (
                    <span
                      aria-hidden="true"
                      style={{ display: "inline-block", width: 24 }}
                    />
                  )}

                  <i
                    style={{
                      color: "#f00",
                    }}
                    className="fa fa-trash"
                    aria-hidden="true"
                    onClick={() =>
                      Alert.ConfirmationMessageBox({
                        Tittle: "Delete Address",
                        Text: "You are deleting the address. Do you wish to continue?",
                        Icon: "warning",
                        ConfirmButtonText: "Yes",
                        ConfirmButtonFunction: async () => {
                          this.UpdateCustomerDeliveryAddress(rs.GUID, true);
                        },
                        DismissButtonFunction: () => {},
                      })
                    }
                  />
                </li>
              ))}
            </>
          </div>
        )}
      </div>
    );
  }

  async SetDefaultCustomerAddress(GUIDAddress) {
    this.setState({ isLoading: true }, async () => {
      if (this.state.AddressList.length > 0) {
        for (let i = 0; i < this.state.AddressList.length; i++) {
          if (this.state.AddressList[i].Add1 !== "") {
            if (this.state.AddressList[i].GUID === GUIDAddress) {
              ENCRYPT_STORAGE.removeItem(STORE_CustomerDefaultAddress);
              ENCRYPT_STORAGE.removeItem(STORE_DeliveryZoneID);
              dto_CustomerAddress.DefaultAdd1 = this.state.AddressList[i].Add1;
              dto_CustomerAddress.DefaultAdd2 = this.state.AddressList[i].Add2;
              dto_CustomerAddress.DefaultAdd3 = this.state.AddressList[i].Add3;
              dto_CustomerAddress.AddressGuid = this.state.AddressList[i].GUID;
              dto_CustomerAddress.PhoneNo = resolveAddressPhoneNo(
                this.state.AddressList[i],
              );
              dto_CustomerAddress.Location = this.state.AddressList[i].Location;
              dto_common.ZoneDescription = this.state.AddressList[i].ZoneDesc;
              await SET_STORE_CUSTOMER_DEFAULT_ADDRESS();

              dto_common.DeliveryZoneID =
                this.state.AddressList[i].DeliveryZoneID;

              if (CSP !== "AV") {
                dto_common.ZoneId = this.state.AddressList[i].DeliveryZoneID;
                await SET_STORE_ZONEID(
                  this.state.AddressList[i].DeliveryZoneID,
                );
                await SET_STORE_DELIVERY_ZONE_DESCRIPTION(
                  this.state.AddressList[i].ZoneDesc,
                );
              }

              await SET_STORE_DELIVERYZONEID(
                this.state.AddressList[i].DeliveryZoneID,
              );
              await this.UpdateCustomerDeliveryAddress(GUIDAddress, false);
              var A = await GET_PAGE_URL();
              this.setState({ isLoading: false });
              ENCRYPT_STORAGE.removeItem(STORE_PAGE_URL);
              this.props.navigate(A);
            }
          }
        }
      }
    });
  }

  async UpdateCustomerDeliveryAddress(GUIDAddress, Inactive) {
    ENCRYPT_STORAGE.removeItem(STORE_CustomerDefaultAddress);
    if (this.state.AddressList.length > 1) {
      let data = await api_UpdateCustomerDeliveryAddress(GUIDAddress, Inactive);
      let objData = JSON.parse(data);
      if (objData === "SUCCESS") {
        let dataAddress = await api_GetCustomerDeliveryAddress();
        let objDataAddress = JSON.parse(dataAddress);
        let objobjDataAddress = JSON.parse(objDataAddress);

        if (objobjDataAddress[0].length > 0) {
          for (let i = 0; i < objobjDataAddress[0].length; i++) {
            if (objobjDataAddress[0][i].Add1 !== "") {
              if (objobjDataAddress[0][i].IsDefault === true) {
                dto_CustomerAddress.DefaultAdd1 = objobjDataAddress[0][i].Add1;
                dto_CustomerAddress.DefaultAdd2 = objobjDataAddress[0][i].Add2;
                dto_CustomerAddress.DefaultAdd3 = objobjDataAddress[0][i].Add3;
                dto_CustomerAddress.AddressGuid = objobjDataAddress[0][i].GUID;
                dto_CustomerAddress.PhoneNo = resolveAddressPhoneNo(
                  objobjDataAddress[0][i],
                );
                dto_CustomerAddress.Location = objobjDataAddress[0][i].Location;
                await SET_STORE_CUSTOMER_DEFAULT_ADDRESS();

                dto_common.DeliveryZoneID =
                  objobjDataAddress[0][i].DeliveryZoneID;
                await SET_STORE_DELIVERYZONEID(
                  objobjDataAddress[0][i].DeliveryZoneID,
                );
              } else {
                if (objobjDataAddress[0].length === 1) {
                  await api_UpdateCustomerDeliveryAddress(
                    objobjDataAddress[0][i].GUID,
                    false,
                  );
                  let Address = await api_GetCustomerDeliveryAddress();
                  let DataAddress = JSON.parse(Address);
                  let objDataAddress = JSON.parse(DataAddress);
                  dto_CustomerAddress.DefaultAdd1 = objDataAddress[0][i].Add1;
                  dto_CustomerAddress.DefaultAdd2 = objDataAddress[0][i].Add2;
                  dto_CustomerAddress.DefaultAdd3 = objDataAddress[0][i].Add3;
                  dto_CustomerAddress.AddressGuid = objDataAddress[0][i].GUID;
                  dto_CustomerAddress.PhoneNo = resolveAddressPhoneNo(
                    objDataAddress[0][i],
                  );
                  dto_CustomerAddress.Location = objDataAddress[0][i].Location;
                  await SET_STORE_CUSTOMER_DEFAULT_ADDRESS();

                  dto_common.DeliveryZoneID =
                    objDataAddress[0][i].DeliveryZoneID;
                  await SET_STORE_DELIVERYZONEID(
                    objDataAddress[0][i].DeliveryZoneID,
                  );
                  dto_CustomerAddressList.dtoAddressList = objDataAddress[0];
                  await SET_STORE_CUSTOMER_ADDRESSLIST();
                  this.setState({
                    AddressList: await Get_CustomerAddressList(),
                  });
                  this.setState({ isLoading: false });
                  return;
                }
              }
            }
          }
          dto_CustomerAddressList.dtoAddressList = objobjDataAddress[0];
          await SET_STORE_CUSTOMER_ADDRESSLIST();
        }
        this.setState({
          AddressList: await Get_CustomerAddressList(),
        });
        this.setState({ isLoading: false });
      }
    } else {
      // if (!Inactive) {
      //   let data = await api_UpdateCustomerDeliveryAddress(
      //     GUIDAddress,
      //     Inactive
      //   );
      // }
      let dataAddress = await api_GetCustomerDeliveryAddress();
      let objDataAddress = JSON.parse(dataAddress);
      let objobjDataAddress = JSON.parse(objDataAddress);
      dto_CustomerAddress.DefaultAdd1 = objobjDataAddress[0][0].Add1;
      dto_CustomerAddress.DefaultAdd2 = objobjDataAddress[0][0].Add2;
      dto_CustomerAddress.DefaultAdd3 = objobjDataAddress[0][0].Add3;
      dto_CustomerAddress.AddressGuid = objobjDataAddress[0][0].GUID;
      dto_CustomerAddress.PhoneNo = resolveAddressPhoneNo(
        objobjDataAddress[0][0],
      );
      dto_CustomerAddress.Location = objobjDataAddress[0][0].Location;
      await SET_STORE_CUSTOMER_DEFAULT_ADDRESS();

      dto_common.DeliveryZoneID = objobjDataAddress[0][0].DeliveryZoneID;
      await SET_STORE_DELIVERYZONEID(objobjDataAddress[0][0].DeliveryZoneID);
      dto_CustomerAddressList.dtoAddressList = objobjDataAddress[0];
      await SET_STORE_CUSTOMER_ADDRESSLIST();
      if (Inactive) {
        await ToastMessage(
          3,
          "Can not delete the address please add alternative adress and delete this",
        );
      }
      this.setState({
        AddressList: await Get_CustomerAddressList(),
      });
      this.setState({ isLoading: false });
    }
  }

  AddressNavgiateBack() {
    if (this.props.params.frompage.toUpperCase() === "PROFILE") {
      this.props.navigate(PT_PROFILE);
    } else if (this.props.params.frompage.toUpperCase() === "CART") {
      this.props.navigate(PT_CART);
    } else if (this.props.params.frompage.toUpperCase() === "HOME") {
      this.props.navigate(PT_HOME);
    }
  }
}
